/* eslint-disable no-unused-vars */

export const defaultFn = () => {};

export const parseJwt = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    console.log('error in token parsing', e);
    return '';
  }
};

export const getRes = (response) => {
  const { data: resData = {} } = response || {};
  return resData;
};

export const getApiErrorMessage = (err) => {
  const data = err?.response?.data ?? err?.data ?? err;

  if (!data) return '';
  if (typeof data === 'string') return data;

  if (data.message && typeof data.message === 'string') return data.message;
  if (data.error_description && typeof data.error_description === 'string')
    return data.error_description;
  if (data.error && typeof data.error === 'string') return data.error;

  if (Array.isArray(data.messages) && data.messages.length) {
    const first = data.messages[0];
    if (typeof first === 'string') return first;
    if (first?.message) return first.message;
  }

  return '';
};
